import { Page, ActivityCard } from '@/components';
import PSM3Icon from '@/components/icons/PSM3Icon';
import { Flex, Heading, NetworkIcon } from '@blockanalitica/ui';
import { useParams } from 'react-router';
import PSM3TotalAssets from './Psm3TotalAssets';
import PSM3AssetsBreakdown from './PSM3AssetsBreakdown';
import { useSparkColor } from '@/hooks';

export default function PSM3Page() {
  const color = useSparkColor();
  const { network } = useParams() as {
    network: string;
  };
  return (
    <Page
      title={
        <Flex gap="2xs" alignItems="center">
          <NetworkIcon network={network} size="3" />
          <PSM3Icon size="5" />
          <Heading size="1">PSM 3</Heading>
        </Flex>
      }>
      <PSM3TotalAssets />
      <PSM3AssetsBreakdown />
      <ActivityCard
        url={`/sparkstar/sll/psm3s/${network}/heatmap/`}
        linkTo="activity"
        onClickUrl="activity"
        color={color}
      />
    </Page>
  );
}
